import { useState } from "react";

export const useStorageState = <T = undefined>(
    storage: Storage,
    key?: string,
    initialValue?: T
): [T, (value: T) => void] => {
    const [value, setValue] = useState<T>(() => {
        if (!key) return;

        try {
            const item = storage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        } catch {
            return initialValue;
        }
    });

    const setStoredValue = (value: T) => {
        if (!key) return;

        try {
            setValue(value);
            if (value == null || value == undefined) storage.removeItem(key);
            else storage.setItem(key, JSON.stringify(value));
        } catch (error) {
            throw new Error(`Error setting storage value (key "${key}"): ${error}`);
        }
    };

    return [value, setStoredValue];
};

export const useLocalStorageState = <T = undefined>(
    key?: string,
    initialValue?: T
): [T, (value: T) => void] => useStorageState(localStorage, key, initialValue);

export const useSessionStorageState = <T = undefined>(
    key?: string,
    initialValue?: T
): [T, (value: T) => void] => useStorageState(sessionStorage, key, initialValue);
